import React from "react";

const CalenderFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 15 17"
      fill="none"
      {...props}
    >
      <path
        d="M4.8125 12.4151V12.3571M8.1875 12.4151V12.3571M8.1875 9.27142V9.21342M11.1875 9.27142V9.21342M2.5625 6.18569H13.0625M3.91964 1.75V2.90728M11.5625 1.75V2.90714M11.5625 2.90714H4.0625C2.81986 2.90714 1.8125 3.94327 1.8125 5.22141V12.9357C1.8125 14.2139 2.81986 15.25 4.0625 15.25H11.5625C12.8051 15.25 13.8125 14.2139 13.8125 12.9357L13.8125 5.22141C13.8125 3.94327 12.8051 2.90714 11.5625 2.90714Z"
        stroke="#616874"
        stroke-width="1.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CalenderFilled;
